<template>
  <div>
    <div class="form-group form-group-default form-multiselect form-multiselect-hubs"
         :class="{ 'form-group-ie': isIE }">
      <div>Pôles : </div>
      <universal-multiselect :label="$t('models.user.hubs')"
                             fieldLabel="name"
                             fieldTrackBy="id"
                             :initialValues="selectedHubs"
                             :availableValues="availableHubs"
                             :placeholder="$t('multiselect.placeholder_hubs')"
                             :validationName="fieldName"
                             :validationTranslation="$t('models.user.hubs')"
                             :disableCondition="disabledConditions"
                             :closeOnSelect="false"
                             :displayLabel="false"
                             @change="onChange($event)" />
    </div>

    <transition name="slide-fade">
      <label v-show="errors.has(fieldName)"
             id="hubs-error"
             class="error"
             :for="fieldName">
        {{ errors.first(fieldName) }}
      </label>
    </transition>
  </div>
</template>

<script>
import UniversalMultiselect from '@/components/form/UniversalMultiselect'

const { detect } = require('detect-browser');

export default {
  name: 'HubsField',
  inject: ['$validator'],
  props: {
    availableHubs: Array,
    selectedHubs: Array,
    disabledConditions: Boolean,
    user: Object,
    fieldNameAddition: { type: [String, Number], default: null },
  },
  components: {
    UniversalMultiselect
  },
  methods: {
    onChange(values) {
      this.$emit('change', values)
    }
  },
  computed: {
    isIE() {
      if (detect()) {
        return detect().name == "ie"
      }
    },
    fieldName() {
      return this.fieldNameAddition ? `hubs_${this.fieldNameAddition}` : 'hubs';
    }
  }
}
</script>

<style lang="scss">
  @import '../../../assets/scss/pages/_var.scss';

  .form-multiselect-hubs {
    border: none;
  }

  .form-multiselect-hubs{
    background-color: #f2f2f2;
    .multiselect__tags {
      background-color: transparent;
    }
    .multiselect__tag-icon:after {
      color: #333;
    }
    .multiselect__single {
      color: $color-pink;
      text-align: right;
      text-decoration: underline;
      font-weight: bold;
      background-color: transparent;
      &:hover {
        cursor: pointer;
      }
    }
    .multiselect--above:hover {
       cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/users/form/HubsField.vue